import React, { type ButtonHTMLAttributes, type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";

export interface MetricButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: JSX.Element;
  label: string;
  className?: string;
}

export const SupMetricButton = ({ icon, label, className, ...buttonProps }: MetricButtonProps) => (
  <span className={twMerge("inline-flex h-10 border-0.5 border-neutral-600 rounded-l-full rounded-br-full overflow-hidden", className)}>
    <span className="inline-flex bg-neutral-500 text-neutral-900 items-center py-2 pl-2 pr-1">
      <span className="inline-flex w-5 h-5 justify-center items-center mr-1">{icon}</span>
      <Text variant="caption">{label}</Text>
    </span>
    <Text
      variant="button"
      weight="bold"
      as="button"
      type="button"
      className="pr-2 pl-1 transition-colors duration-200 bg-neutral-50 text-neutral-600 enabled:hover:bg-neutral-700 enabled:hover:text-neutral-50 enabled:focus:bg-neutral-300 enabled:focus:text-neutral-600 enabled:active:bg-neutral-800 enabled:active:text-neutral-700"
      {...buttonProps}
    />
  </span>
);
